import type { Tenant, UpdateTenant } from '@servicetim/shared';
import { adminPath, useApiContext } from '@servicetim/ui/api';
import { useMutation } from '@tanstack/react-query';

/**
 * `PATCH /admin/v1/tenant` carrying `If-Match: <configVersion>`. The API does not enforce the
 * header on the tenant yet (it always bumps `configVersion`); sending it costs nothing and the
 * screen already handles a 409/412 through `ConflictDialog` for the day it does.
 * (Local variant of `useUpdateTenant` from `@/api`; integrator may fold `ifMatch` into it.)
 */
export function useUpdateTenantIfMatch() {
  const { request, keys, invalidate } = useApiContext();
  return useMutation({
    mutationFn: ({ patch, ifMatch }: { patch: UpdateTenant; ifMatch: number }) =>
      request<Tenant>('PATCH', adminPath('/tenant'), { body: patch, ifMatch }),
    onSuccess: () => invalidate(keys.tenant, keys.me),
  });
}
